







import { TicketParams } from '@/store/interfaces/tickets';
import Vue, { PropType } from 'vue';
import datesDescription from './datesDescription.vue';
import Refund from './refund.vue';

export default Vue.extend({
  name: 'PaymentRefund',
  components: {
    datesDescription,
    Refund,
  },
  props: {
    ticket: {
      type: Object as PropType<TicketParams>,
      required: true,
    },
  },
});
